// Angular imports
import { Directive, HostListener } from '@angular/core';

// CC-Common imports
import { Utils } from 'cc-common';

// Service imports
import { ContextManagerService } from '../../_services/data-services/context-manager.service';
import { UserService } from '../../_services/data-services/user.service';

// Model imports
import { ActionAccessListParameterDto } from '../../_models/action-access-list-parameter-dto';
import { ActionAccessResultDto } from '../../_models/action-access-result-dto';
import { PropertyCommunityInfoResultDto } from '../../_models/property-community-info-result-dto';

@Directive({
    selector: '[appHasRestrictedColumns]'
})
export class HasRestrictedColumnsDirective {
    selectedContext: PropertyCommunityInfoResultDto;

    constructor(
        private readonly contextManagerService: ContextManagerService,
        private readonly userService: UserService
    ) {}

    @HostListener('onInitialized', ['$event'])
    onInitialized(event: any): void {
        this.selectedContext = this.contextManagerService.getSelectedContext();
        setTimeout(() => this.checkActionAccess(event), 500);
    }

    private checkActionAccess(event: any): void {
        const params: ActionAccessListParameterDto = new ActionAccessListParameterDto();
        params.communityId =
            Utils.notNullAndDefined(this.selectedContext) && Utils.notNullAndDefined(this.selectedContext.communityId)
                ? this.selectedContext.communityId
                : null;
        params.customerId =
            Utils.notNullAndDefined(this.selectedContext) && Utils.notNullAndDefined(this.selectedContext.customerId)
                ? this.selectedContext.customerId
                : null;
        params.clearCache = false;

        this.userService.getActionList(params).subscribe((actions: ActionAccessResultDto[]) => {
            const actionCodes = actions.map((d) => d.code);
            let columns = event.component.option('columns');
            if (Utils.isTrue(event.component.option('stateStoring').enabled)) {
                const state = event.component.state() || {};
                columns = state.columns || columns;
            }
            columns.forEach((c) => {
                if (c.name.includes('RestrictedColumn|')) {
                    const accessCode = c.name.split('|')[1];
                    if (Utils.notInList(accessCode, actionCodes)) {
                        c.visible = c.showInColumnChooser = false;
                    }
                }
            });
        });
    }
}
